import { render } from "./signUp.vue?vue&type=template&id=35ba02ab&scoped=true&bindings={\"firstName\":\"data\",\"lastName\":\"data\",\"email\":\"data\",\"confirm_password\":\"data\",\"password\":\"data\",\"phone_number\":\"data\",\"gender\":\"data\",\"SignUp\":\"options\"}"
import script from "./signUp.vue?vue&type=script&lang=js"
export * from "./signUp.vue?vue&type=script&lang=js"

import "./signUp.vue?vue&type=style&index=0&id=35ba02ab&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-35ba02ab"

export default script